import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const RevealLine = ({ children, delay = 0, className = "" }) => (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
            className={`block ${className}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const ScrollReveal = ({ children, delay = 0, className = "", y = 48 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const ChapterHeading = ({ index, title, className = "" }) => (
    <ScrollReveal className={className}>
        <div className="flex items-end gap-4 md:gap-6">
            <span className="font-heading text-copper text-lg md:text-xl font-medium tracking-widest">
                {index}
            </span>
            <span className="h-px flex-1 bg-[#D9D9D9] mb-2" />
            <span className="text-sm uppercase tracking-[0.25em] text-[#595959] mb-0.5">
                {title}
            </span>
        </div>
    </ScrollReveal>
);
